module.exports = Immutable;


//////////////////
// WEBPACK FOOTER
// external "Immutable"
// module id = 31
// module chunks = 0 2 3 4 5 6